module.exports = __webpack_public_path__ + "img/video_bg.10583371.png";